import { validationTypes } from "../../../../components/finalForms/libs/data/ValidationTypes"
import { FormFieldTypes } from "../../../../components/finalForms/libs/data/formFieldType"
import { GridColumnType } from "../../../../data/gridColumnType"


const initState = {
  statusName: '',
  isActive: true,
  isComplete: '',
  isDefault: '',
}

export const planningStatusFormData = {
  name: "Planning Status Form",
  initialState: initState,
  section: [
    {
      sectionId: 'PlanningStatus',
      title: "Planning Status",
      row: {},
      style: {
        sectionStyle: "row",
      },
      wrappperTemplate: <div className="form-card row"></div>,
      fields: [
        {
          id: "statusName",
          label: "Planning Status Name",
          Field_Name: "planning status",
          fieldType: FormFieldTypes.INPUT,
          dataField: "statusName",
          fieldSetting: {
            placeholder: "Please Enter Planning Status",
            allowSpace: true,
            // isDisable: false,
            maxLength: 30,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12   col-md-12 mb-1 validation-left-0",
          },
        },
        {
          id: "isActive",
          label: "Is Active",
          Field_Name: "isactive",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isActive",
          fieldSetting: {
            allowSpace: true,
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 col-4 validation-left-0",
          },
        },
        {
          id: "isComplete",
          label: "Is Complete",
          Field_Name: "iscomplete",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isComplete",
          fieldSetting: {
            allowSpace: true,
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 col-4 validation-left-0",
          },
        },
        {
          id: "isDefault",
          label: "Is Default",
          Field_Name: "isdefault",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isDefault",
          fieldSetting: {
            allowSpace: true,
          },
          // validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-4 col-md-4 col-4 validation-left-0",
          },
        },
      ]
    }
  ]
}

export const planningStatusGridConfig = {
  columns: [
    {
      name: "Planning Status",
      fieldName: "statusName",
      allowShort: false,
      colStyle: {
        width: "43%",
        textAlign: "center",
      },
    },
    {
      name: "is Active",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isActive",
      allowShort: false,
      colStyle: {
        width: "43%",
        textAlign: "center",
      },
      colSettings: {
        isDisabled: true
      },
    },
    {
      name: "is Complete",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isComplete",
      allowShort: false,
      colStyle: {
        width: "43%",
        textAlign: "center",
      },colSettings: {
        isDisabled: true
      },
    },
    {
      name: "is Default",
      colType: GridColumnType.CHECKBOX,
      fieldName: "isDefault",
      allowShort: false,
      colStyle: {
        width: "43%",
        textAlign: "center",
      },
      colSettings: {
        isDisabled: true
      },
    },

    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
      colStyle: {
        width: "14%",
        textAlign: "center",
      },
    },
  ],
}